import axios from 'axios'
import store from '@/store'
import global from './global'

export default {
  /**
   * Make GET request to given url
   * Returns placeholderData in debug mode
   *
   * @param {String} url
   * @param {Object} placeholderData
   * @returns {Promise}
   */
  get (url, placeholderData) {
    if (store.getters['system/inDebugMode']) {
      return global.methods.resolveWith(placeholderData)
    }

    return axios.get(url)
  },

  /**
   * Make POST request to given url
   * Returns placeholderData in debug mode
   *
   * @param {String} url
   * @param {Object} data
   * @param {Object} placeholderData
   * @returns {Promise}
   */
  post (url, data, placeholderData) {
    if (store.getters['system/inDebugMode']) {
      return global.methods.resolveWith(placeholderData)
    }

    return axios.post(url, data)
  },

  /**
   * Return simplified array with laravel validation errors
   * Each validated field gets its first error message
   *
   * e.g. {
   *   message: "There are some",
   *   errors: {
   *     email: "Invalid format of email.",
   *     password: "This field is required."
   *   }
   * }
   *
   *
   * @param {Error} error
   * @returns {Object}
   */
  getValidationErrors (error) {
    const errors = []
    let message = ''

    if (error.response) {
      const reactiveErrors = Object.assign({}, error.response.data.error.errors)

      for (var key in reactiveErrors) {
        errors[key] = reactiveErrors[key][0]
      }

      message = error.response.data.error.message
    }

    return {
      errors,
      message,
    }
  }
}
